import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BuyerService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("token");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }
  1.5;

  submitOffer(data) {
    return this.http.post(`${this.baseUrl}/api/sendOffer`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  submitOfferPage(data) {
    return this.http.post(`${this.baseUrl}/api/submitOffer`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getSavedOffers(buyerId) {
    return this.http.get(`${this.baseUrl}/api/getSaveoffer?uid=${buyerId}`, {
      headers: this.getAuthHeaders(),
    });
  }

  getAllSubmitOffers(buyerId) {
    return this.http.get(
      `${this.baseUrl}/api/getAllSubmitOffer?uid=${buyerId}`,
      { headers: this.getAuthHeaders() },
    );
  }

  buyerContentListUid(buyer_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/getBuyeroffer?buyer_id=${buyer_id}`,
      { headers: this.getAuthHeaders() },
    );
  }

  getAllOfferList(buyer_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/getAllSubmitOfferbuyer?buyer_id=${buyer_id}`,
      { headers: this.getAuthHeaders() },
    );
  }

  getBuyerAllSeason(content_id): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/allseason?content_id=${content_id}`,
      { headers: this.getAuthHeaders() },
    );
  }

  getBuyerAllEpisode(content_id, season) {
    return this.http.get(
      `${this.baseUrl}/api/allepisode?content_id=${content_id}&season=${season}`,
      { headers: this.getAuthHeaders() },
    );
  }

  offerHistoryPage(uid, offer_id) {
    return this.http.get(
      `${this.baseUrl}/api/offerHistoryseller?offer_id=${offer_id}&uid=${uid}`,
      { headers: this.getAuthHeaders() },
    );
  }

  resubmitOfferPage(data) {
    return this.http.post(`${this.baseUrl}/api/submitOffer`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  acceptOffer(buyer_id, offer_id) {
    return this.http.get(
      `${this.baseUrl}/api/accept-offer?offer_id=${offer_id}&uid=${buyer_id}`,
      { headers: this.getAuthHeaders() },
    );
  }

  contactUSForm(data) {
    return this.http.post(`${this.baseUrl}/api/get-in-touch`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getSellerNotificaton(data) {
    return this.http.get(`${this.baseUrl}/api/get-notification?uid=${data}`, {
      headers: this.getAuthHeaders(),
    });
  }

  markReadNotification(data) {
    return this.http.get(
      `${this.baseUrl}/api/mark-read-notification?id=${data}`,
      { headers: this.getAuthHeaders() },
    );
  }

  addHitListData(id) {
    return this.http.post(`${this.baseUrl}/api/updateTrendingContent`, id, {
      headers: this.getAuthHeaders(),
    });
  }

  addWatchlistData(data) {
    return this.http.post(`${this.baseUrl}/api/add-watch-list`, data, {
      headers: this.getAuthHeaders(),
    });
  }

  viewContent(data) {
    return this.http.get(`${this.baseUrl}/api/viewcontent`, {
      ...data,
      headers: this.getAuthHeaders(),
    });
  }

  getWatchListData(buyer_id) {
    return this.http.get(`${this.baseUrl}/api/get-watch-list?id=${buyer_id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteWatchList(tag) {
    return this.http.post(`${this.baseUrl}/api/deletewatchlistcontent`, tag, {
      headers: this.getAuthHeaders(),
    });
  }

  woohooList(uid: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/woolist/?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }

  updateWoohoo(uid: number, ides: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/update_woo/?uid=${uid}&ids=${ides}`,
      { headers: this.getAuthHeaders() },
    );
  }
  offerSkipped(uid: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/setofferdialog?uid=${uid}`, {
      headers: this.getAuthHeaders(),
    });
  }
  setContentView(uid, content_id) {
    return this.http.post(
      `${this.baseUrl}/api/setcontentview`,
      { uid, content_id },
      { headers: this.getAuthHeaders() },
    );
  }
}
